"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _List = require("react-mdl/lib/List");

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _UserService = _interopRequireWildcard(require("./services/UserService"));

var _UserLogsService = _interopRequireDefault(require("./services/UserLogsService"));

var _EquizzerActions = _interopRequireDefault(require("./actions/EquizzerActions"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _QuizHome = _interopRequireDefault(require("./QuizHome.scss"));

var _QuizHighScores = _interopRequireDefault(require("./QuizHighScores.scss"));

var _QuizStrings = require("./QuizStrings");

var _QuizHighScoreStyle = require("./styles/QuizHighScoreStyle");

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _AlertHelper = require("../../../helpers/AlertHelper");

var _NavigationManager = _interopRequireDefault(require("../../NavigationManager"));

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

var _ErrorHelper = require("../../../helpers/ErrorHelper");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var HIGHSCORE_LISTS = {
  DAY: 'day',
  MONTH: 'month',
  TOTAL: 'total'
};
var CHUNK_SIZE = 20;

var QuizHighScores = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(QuizHighScores, _DataStoreComponent);

  var _super = _createSuper(QuizHighScores);

  function QuizHighScores(props) {
    var _thisSuper, _thisSuper2, _this;

    (0, _classCallCheck2["default"])(this, QuizHighScores);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUser", function () {
      var filteredUsers = _config["default"].hideRobotsInHighscore ? _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_USERS].filter(function (user) {
        return !user.isRobot;
      }) : _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_USERS];
      var sortedUser = filteredUsers.sort(function (obj1, obj2) {
        if (obj1.points < obj2.points) return 1;
        if (obj1.points > obj2.points) return -1;

        if (obj1.points === obj2.points) {
          if (obj1.nickname.toLowerCase() > obj2.nickname.toLowerCase()) return 1;
          if (obj1.nickname.toLowerCase() < obj2.nickname.toLowerCase()) return -1;
          return 0;
        }

        return 0;
      });
      sortedUser.forEach(function (user, index) {
        if (index > 0) {
          if (user.points === sortedUser[index - 1].points) {
            user.rank = sortedUser[index - 1].rank;
          } else {
            user.rank = index + 1;
          }
        } else {
          user.rank = 1;
        }
      });

      _this.recursive(filteredUsers);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "recursive", function (user) {
      _this.timer = setTimeout(function () {
        if (_this.unmount) return;
        var hasMore = _this.state.userToRender.length + CHUNK_SIZE < user.length;

        if (_this.state.userToRender.length < user.length) {
          _this.setState(function (prev, props) {
            return {
              userToRender: user.slice(0, prev.userToRender.length + CHUNK_SIZE)
            };
          });
        }

        if (hasMore) {
          _this.recursive(user);
        } else {
          _this.timer = null;
          console.log('INFO', 'QuizHighScores', 'all lines rendered', user.length);
        }
      }, 0);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "innerForceUpdate", function () {
      _this.forceUpdate();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateTab", function () {
      console.log('updating highscores');

      if (!_this.currentlyUpdating) {// this.updateHighscores()
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateHighscores", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var user, userAuth, playgrouIdToUse, groupUsers, storedImages, groupUsersWithImage;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              user = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER];
              _context.next = 4;
              return _this.props.getAuthToken();

            case 4:
              userAuth = _context.sent;
              playgrouIdToUse = user.playgroupId ? user.playgroupId : _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_ID);
              _context.next = 8;
              return _UserService["default"].getAllUsersAndLoadTheme(playgrouIdToUse, userAuth);

            case 8:
              groupUsers = _context.sent;

              if (!groupUsers) {
                _context.next = 16;
                break;
              }

              storedImages = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_IMAGE_PATH];
              _context.next = 13;
              return _UserService["default"].getUserImages(groupUsers, _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_USERS].groupUsers, userAuth, storedImages);

            case 13:
              groupUsersWithImage = _context.sent;

              // set groupUsers application state
              // to have the updated highscores
              _EquizzerActions["default"].setGroupUsers(groupUsersWithImage); // for(let key in groupUsersWithImage) {


              groupUsersWithImage.forEach(function (groupUser) {
                // const groupUser = groupUsersWithImage[key]
                var loggedUser = _this.state.user;

                if (groupUser.id === loggedUser.id) {
                  loggedUser.picture = groupUser.picture; // set user application state

                  console.log('set user updateHighscores quizHighscores.js', groupUser);

                  _EquizzerActions["default"].setUser(groupUser, 'QuizHighscores');

                  _EquizzerActions["default"].setUserPoints(groupUser.points);
                }
              });

            case 16:
              _context.next = 21;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](0);
              console.log('ERROR: updating highscores', _context.t0);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 18]]);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toggleTabs", function (e) {
      var className = e.target.className;

      switch (className) {
        case 'dailyTab':
          _this.setState({
            currentList: HIGHSCORE_LISTS.DAY
          });

          document.querySelector('.totalTab').classList.remove(_QuizHighScores["default"].active);
          document.querySelector('.monthlyTab').classList.remove(_QuizHighScores["default"].active);
          break;

        case 'monthlyTab':
          _this.setState({
            currentList: HIGHSCORE_LISTS.MONTH
          });

          document.querySelector('.dailyTab').classList.remove(_QuizHighScores["default"].active);
          document.querySelector('.totalTab').classList.remove(_QuizHighScores["default"].active);
          break;

        case 'totalTab':
        default:
          _this.setState({
            currentList: HIGHSCORE_LISTS.TOTAL
          });

          document.querySelector('.dailyTab').classList.remove(_QuizHighScores["default"].active);
          document.querySelector('.monthlyTab').classList.remove(_QuizHighScores["default"].active);
          break;
      }

      e.target.classList.add(_QuizHighScores["default"].active);
    });
    _this.state = {
      currentList: HIGHSCORE_LISTS.TOTAL,
      scrollHeight: window.innerHeight - 250,
      scrollArrow: false,
      userDetails: null,
      userImage: false,
      userToRender: []
    };
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(QuizHighScores.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.QD_USER_IMAGE_PATH, _DataStore.DATA_STORE_PATHS.QD_USER, _DataStore.DATA_STORE_PATHS.QD_ALL_GAME, _DataStore.DATA_STORE_PATHS.QD_GROUP_USERS, _DataStore.DATA_STORE_PATHS.QD_OPPONENTS, _DataStore.DATA_STORE_PATHS.QD_USER_AUTH, _DataStore.DATA_STORE_PATHS.QD_PRESENCES, _DataStore.DATA_STORE_PATHS.QD_SHOW_PRESENCES, _DataStore.DATA_STORE_PATHS.QD_COMPLETED_GAME_IDS, _DataStore.DATA_STORE_PATHS.QD_EXPIRED_GAME_IDS]);
    (0, _get2["default"])((_thisSuper2 = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(QuizHighScores.prototype)), "addStoresAndKeys", _thisSuper2).call(_thisSuper2, [{
      store: _ThemeStore["default"],
      keys: ['currentTheme', 'quiz', 'navbar']
    }]);
    _this.showOrHideTimeout = null;
    _this.currentlyUpdating = false;
    _this.unmount = false;
    return _this;
  }

  (0, _createClass2["default"])(QuizHighScores, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getUser();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this2 = this;

      if (this.props.hidden === true && !prevProps.hidden) {
        clearTimeout(this.showOrHideTimeout);
        this.showOrHideTimeout = setTimeout(function () {
          _this2.onHideOrUnmount();
        }, 500);
      } else if (!this.props.hidden && prevProps.hidden) {
        clearTimeout(this.showOrHideTimeout);
        this.showOrHideTimeout = setTimeout(function () {
          _this2.onShowOrMount();
        }, 500);
      }
    }
    /*
    componentWillReceiveProps (nextProps) {
      if (nextProps.hidden === true && !this.props.hidden) {
        clearTimeout(this.showOrHideTimeout)
        this.showOrHideTimeout = setTimeout(() => {
          this.onHideOrUnmount()
        }, 500)
      }
      else if (!nextProps.hidden && this.props.hidden) {
        clearTimeout(this.showOrHideTimeout)
        this.showOrHideTimeout = setTimeout(() => {
          this.onShowOrMount()
        }, 500)
      }
    }
    */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.showOrHideTimeout);
      this.onHideOrUnmount();
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(QuizHighScores.prototype), "componentWillUnmount", this).call(this);

      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.unmount = true;
    }
  }, {
    key: "onHideOrUnmount",
    value: function onHideOrUnmount() {
      _DeviceInfoHelper["default"].removeOnlineListener(this.innerForceUpdate);

      _DeviceInfoHelper["default"].removeOfflineListener(this.innerForceUpdate);

      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.unmount = true;
    }
  }, {
    key: "onShowOrMount",
    value: function onShowOrMount() {
      // this.props.setTitle(getString('HIGHSCORES'));
      // LOG: user events
      this.unmount = false;

      _UserLogsService["default"].postHighScoreScreenViewedLog(this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id);

      _NavigationManager["default"].setCurrentLocation('quiz highscores');

      this.updateTab();

      _DeviceInfoHelper["default"].addOnlineListener(this.innerForceUpdate);

      _DeviceInfoHelper["default"].addOfflineListener(this.innerForceUpdate);
    }
  }, {
    key: "getGameWithOpponent",
    value: function getGameWithOpponent(opponent) {
      return this.state.data[_DataStore.DATA_STORE_PATHS.QD_ALL_GAME].find(function (game) {
        return game.opponent === opponent.id;
      });
    }
  }, {
    key: "renderTabs",
    value: function renderTabs() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizHighScores["default"].tabsContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "totalTab ".concat(_QuizHighScores["default"].active),
        onClick: this.toggleTabs
      }, (0, _QuizStrings.getString)('TOTAL')), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'dailyTab',
        onClick: this.toggleTabs
      }, (0, _QuizStrings.getString)('DAILY')), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'monthlyTab',
        onClick: this.toggleTabs
      }, (0, _QuizStrings.getString)('MONTHLY')));
    }
  }, {
    key: "startNewGame",
    value: function startNewGame(user) {
      var _this3 = this;

      var okButton = {
        label: (0, _QuizStrings.getString)('LETS_GO'),
        callback: function callback() {
          _this3.props.onSetOpponent(user);
        }
      };
      var cancelButton = {
        label: (0, _QuizStrings.getString)('NOT_NOW'),
        callback: function callback() {}
      };
      (0, _AlertHelper.showAlertWithOptions)({
        html: (0, _QuizStrings.getString)('START_NEW_GAME', [user.nickname]),
        title: (0, _QuizStrings.getString)('NEW_GAME'),
        centeredContent: true,
        buttons: [cancelButton, okButton]
      }); // showWideAlertHtml(getString('START_NEW_GAME', [user.nickname]), getString('NEW_GAME'), true, [okButton, cancelButton]);
    }
  }, {
    key: "renderPresence",
    value: function renderPresence(opponent) {
      if (this.state.data[_DataStore.DATA_STORE_PATHS.QD_SHOW_PRESENCES]) {
        var presences = this.state.data[_DataStore.DATA_STORE_PATHS.QD_PRESENCES];
        var isPresent = opponent.isRobot || presences && Boolean(presences[opponent.nickname]);
        var isInvisible = !opponent.isRobot && isPresent && !this.state.data[_DataStore.DATA_STORE_PATHS.QD_PRESENCES][opponent.nickname].showOnlineState;
        var cssClass;
        var content = '';

        if (window.ablyConnectivity.state !== 'connected') {
          cssClass = _QuizHome["default"].deviceOffline;
        } // else if (isInvisible) {
        //   cssClass = styles.userInvisible
        //   content = '?'
        // }
        else if (isPresent && !isInvisible) {
            cssClass = _QuizHome["default"].userOnline;
          } else {
            cssClass = _QuizHome["default"].userOffline;
          }

        return /*#__PURE__*/_react["default"].createElement("div", {
          className: cssClass
        }, content);
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      // if(!this.state.groupUsers) {
      //   return (<div>loading...</div>);
      // }
      var userDetails = _UserService["default"].mapOpponentsInfoToId(this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_USERS]);

      var dynamicStyles = (0, _QuizHighScoreStyle.getStyles)(this.state, this.props);
      var filteredUsers = this.state.userToRender;
      console.log('filteredUsers', filteredUsers);
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "innerContent",
        style: dynamicStyles.outerStyle,
        className: _QuizHome["default"].innerContent
      }, filteredUsers.map(function (groupUser, index) {
        var game = _this4.getGameWithOpponent(groupUser);

        var nicknameToUse = groupUser.nickname;

        if (_config["default"].sortPlayersByLastName) {
          var nicknameArray = groupUser.nickname.split(' ');
          nicknameToUse = nicknameArray.length > 1 ? "".concat(nicknameArray[1], ", ").concat(nicknameArray[0]) : groupUser.nickname;
        }

        var image;

        if (_this4.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id === groupUser.id && _this4.props.userImage) {
          image = _this4.props.userImage;
        } else if (userDetails[groupUser.id].picture) {
          image = userDetails[groupUser.id].picture;
        } else {
          image = _UserService.DEFAULT_IMAGE;
        }

        return /*#__PURE__*/_react["default"].createElement(_List.ListItem, {
          key: "score_".concat(groupUser.id),
          className: _QuizHome["default"].listItem,
          onClick: _this4.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id === groupUser.id ? function () {} : game ? function () {
            return _this4.props.onShowResults(game, groupUser);
          } : function () {
            return _this4.startNewGame(groupUser);
          }
        }, /*#__PURE__*/_react["default"].createElement(_List.ListItemContent, {
          className: _this4.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id === groupUser.id ? _QuizHome["default"].userText : _QuizHome["default"].opponentsText,
          style: _this4.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id === groupUser.id ? dynamicStyles.userPointsStyle : dynamicStyles.opponentPointsStyle
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _QuizHome["default"].spanRank
        }, "".concat(groupUser.rank, ".")), /*#__PURE__*/_react["default"].createElement("div", {
          className: _QuizHome["default"].highScoreThumb
        }, /*#__PURE__*/_react["default"].createElement("img", {
          alt: "img",
          src: image
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: _QuizHome["default"].spanText
        }, _this4.renderPresence(groupUser), " ", nicknameToUse)), /*#__PURE__*/_react["default"].createElement("div", {
          className: _this4.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id === groupUser.id ? _QuizHome["default"].userPoints : _QuizHome["default"].opponentPoints,
          style: _this4.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id === groupUser.id ? dynamicStyles.userPointsStyle : dynamicStyles.opponentPointsStyle
        }, groupUser.points));
      }));
    }
  }]);
  return QuizHighScores;
}(_DataStoreComponent2["default"]);

exports["default"] = QuizHighScores;
QuizHighScores.propTypes = {
  showSpinner: _propTypes["default"].func.isRequired,
  onShowResults: _propTypes["default"].func.isRequired,
  onSetOpponent: _propTypes["default"].func.isRequired,
  getAuthToken: _propTypes["default"].func.isRequired,
  hidden: _propTypes["default"].bool
};